import React from "react";
import styled from "styled-components";
import {
  Button as AIMEButton,
  Input as AIMEInput,
} from "tot-loft-component-library";
import StatusBadge from "./StatusBadge";

const normalizeStatus = (status = "") => status.trim().toLowerCase();

// Updated Color Map
const STATUS_COLORS = {
  successful: "rgba(18, 124, 78, 0.1)",
  tracking: "rgba(244, 186, 52, 0.1)",
  unsuccessful: "rgba(240, 70, 63, 0.1)",
  paid: "rgba(89, 84, 222, 0.1)",
  all: "rgba(100, 116, 139, 0.1)",
};

// Updated Text Color Map
const STATUS_TEXT_COLORS = {
  successful: "rgb(18, 124, 78)",
  tracking: "rgb(244, 186, 52)",
  unsuccessful: "rgb(240, 70, 63)",
  paid: "rgb(89, 84, 222)",
  all: "rgb(100, 116, 139)",
};

const ReferralStatusCard = ({
  status,
  statusMessage,
  icon,
  note,
  updatedAt,
  onChangeStatus,
  showCustomWon,
  LostReason,
}) => {
  return (
    <StatusBars>
      <Frame1466 status={status}>
        <Frame1468>
          <StatusBadge status={status} showCustomWon={showCustomWon} />

          <Frame1525>
            <LeadIdentified status={status}>{status}</LeadIdentified>
            <TheVendorWillEngageWithTheMemberToLearnMoreContextAboutTheReferralSubmitted>
              {statusMessage}
            </TheVendorWillEngageWithTheMemberToLearnMoreContextAboutTheReferralSubmitted>

            {normalizeStatus(status) === "unsuccessful" && (
              <ReasonNoFitNotIdealClientProfile>
                Reason: {LostReason}
              </ReasonNoFitNotIdealClientProfile>
            )}
          </Frame1525>
        </Frame1468>
        <Frame1470>
          <UpdatedAt2Apr2025>Updated at: {updatedAt}</UpdatedAt2Apr2025>
        </Frame1470>
      </Frame1466>
    </StatusBars>
  );
};

export default ReferralStatusCard;

const StatusBars = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1466 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  align-self: stretch;
  background: ${({ status }) => {
    const key = normalizeStatus(status || "all");
    return STATUS_COLORS[key] || "rgba(100, 116, 139, 0.1)";
  }};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 24px;
  flex-shrink: 0;
  flex-wrap: wrap;
`;

const Frame1468 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 16px;
  width: 824px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1428 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 4px;
  border-radius: 999px;
  width: 48px;
  height: 48px;
  background: linear-gradient(
    -90deg,
    rgba(89, 84, 222, 0.1),
    rgba(89, 84, 222, 0.1)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const User = styled.span`
  color: rgb(89, 84, 222);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: "Font Awesome 6 Pro", sans-serif;
  font-weight: 400;
  line-height: 160%;
  text-align: center;
`;

const Frame1525 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 760px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const LeadIdentified = styled.span`
  color: ${({ status }) => {
    const normalized = normalizeStatus(status || "all");
    return STATUS_TEXT_COLORS[normalized] || "rgb(100, 116, 139)";
  }};
  text-overflow: ellipsis;
  font-size: clamp(1rem, 2.5vw, 20px);
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
`;

const TheVendorWillEngageWithTheMemberToLearnMoreContextAboutTheReferralSubmitted = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1437 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Note = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 713px;
  flex: 1;
`;

const ReasonNoFitNotIdealClientProfile = styled.span`
  color: rgb(240, 70, 63);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
`;

const Frame1470 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const UpdatedAt2Apr2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;
